import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { OnDestroy } from '@angular/core';
import { AppState } from 'src/app/store/app.states';
import { ComponentBase } from 'src/app/views/component-base';

@Component({
    selector: 'app-investment-tooltip',
    templateUrl: './investment-tooltip.component.html',
    styleUrls: ['./investment-tooltip.component.scss'],
    imports: [
    ],
})
export class InvestmentTooltipComponent
    extends ComponentBase
    implements OnInit, OnDestroy {

    @Output() onSelected = new EventEmitter<any>();

    @Input() set tooltipText(value: string) {
        this._tooltipText = value;
    }

    _tooltipText: string = null;

    constructor(public store: Store<AppState>) {
        super();
    }

    async ngOnInit() {
        super.ngOnInitBase();
    }

    ngOnDestroy(): void {
        super.ngOnDestroyBase();
    }
}
